import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Contact Us </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      <b>Custom development</b>
                      <br></br>
                      If you are a business owner and want to use XR in your business, we are here to help you.
                      Please visit our <a href="/customdev">Custom Development</a> guidelines and 
                      email us on: contact@icomputinglabs.in.
                      <br />
                      We promise to get back to you within 24 hours.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Customer Care</b>
                      <br></br>
                      If you are a user of AbilitàXR and have any queries, or want to report a bug, 
                      or want to appreciate our product, or just want to drop a line to say hello, 
                      please email us on: contact@icomputinglabs.in.
                      <br></br>
                      We promise to get back to you within 24 hours.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Complaint</b>
                      <br></br>
                      If you have any complaints or have any issues with any of the content 
                      that is displayed on the site, then you can again contact us at 
                      contact@icomputinglabs.in and request to raise a complaint.
                      <br></br>
                      If your concern still remains unresolved, please drop an email to: manish@icomputinglabs.in.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      AbilitàXR is brought to you by iComputinglabs Technologies Private Limited (CIN: U72900KA2017PTC106154). 
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                    <h6 className = "mt-4 line-height-h">
                      <br></br><br></br>
                    </h6>
                  </Col>
                </Row>
                
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/views/Pages/Contact/Contact.js